import { AttendeeSurvey, SurveyQuestion } from '../../../models/survey';
import { cleanUnregisteredQuestionAnswers } from './';

const isString = (variable: unknown): variable is string =>
    typeof variable === 'string';
const isObject = (variable: unknown): variable is Record<string, unknown> =>
    !!variable && typeof variable === 'object' && !Array.isArray(variable);

export const cleanFormData = (
    formData: {
        [key: string]: any;
    },
    survey: {
        questionsForBasicInfo: Array<SurveyQuestion>;
        questionsForBuyer: Array<SurveyQuestion>;
        questionsForAttendees: AttendeeSurvey;
    },
) => trimStringPropsObject(cleanUnregisteredQuestionAnswers(formData, survey));

export const trimStringPropsObject = <Data extends Record<string, unknown>>(
    data: Data,
): Data =>
    Object.fromEntries(
        Object.entries(data).map(([key, value]) => {
            if (isString(value)) {
                return [key, value.trim()];
            }

            return [
                key,
                isObject(value) ? trimStringPropsObject(value) : value,
            ];
        }),
    ) as Data;
